export const editorDefaultValue = `openapi: 3.0.2
paths:
  /push-signal:
    post:
      summary: Push Signal
      tags: []
      parameters:
        - name: authorization
          in: header
          required: true
          schema:
            type: string
      requestBody:
        description: Body
        content:
          application/json:
            schema:
              type: object
              properties:
                signalType:
                  type: string
                  enum:
                    - CREATE
                    - UPDATE
                    - DELETE
                    - SEEDUPDATE
                objectId:
                  type: string
                eserviceId:
                  type: string
                signalId:
                  type: number
              required:
                - signalType
                - objectId
                - eserviceId
                - signalId
      responses:
        '200':
          description: '200'
          content:
            application/json:
              schema:
                type: object
                properties:
                  signalId:
                    type: number
                required:
                  - signalId
        '400':
          description: '400'
        '401':
          description: '401'
        '403':
          description: '403'
        '429':
          description: '429'
info:
  title: Push signal Service API
  version: '1.0'

`;
